import type { AppState, AppAction } from '../appReducerTypes';

export function uiReducer(state: AppState, action: AppAction): AppState {
  switch (action.type) {
    case 'SET_ACTIVE_PAGE':
      return { ...state, activePage: action.payload };
    default:
      return state;
  }
}
